module.exports = __webpack_public_path__ + "img/managertips_sm.3b428e43.png";